/**
 * Hides off-screen, faded-out and loop-copy slides from screen readers and tab order.
 * Sliding effects need `watchSlidesVisibility: true`; fade stacks slides, so only the active one counts.
 *
 * @param {Swiper} swiper
 * @returns {void}
 */
function syncSlidesAccessibility(swiper) {
    const visibleClass =
        swiper.params.effect === 'fade'
            ? swiper.params.slideActiveClass
            : swiper.params.slideVisibleClass;

    Array.from(swiper.slides).forEach((slide) => {
        const isHidden = !slide.classList.contains(visibleClass);

        // Runs on every progress frame, so only touch the DOM when the state flips
        if (slide.hasAttribute('inert') === isHidden) {
            return;
        }

        slide.setAttribute('aria-hidden', String(isHidden));
        slide.toggleAttribute('inert', isHidden);
    });
}

/**
 * Keeps slide visibility in sync for the slider's life and clears it on destroy.
 *
 * @param {Swiper} swiper
 * @returns {void}
 */
function watchSlidesAccessibility(swiper) {
    syncSlidesAccessibility(swiper);

    // Sync when a move starts, not only at its end: transitionEnd can arrive seconds late on mobile
    swiper.on('progress transitionStart transitionEnd', () =>
        syncSlidesAccessibility(swiper),
    );

    swiper.on('beforeDestroy', () => {
        Array.from(swiper.slides).forEach((slide) => {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
        });
    });
}

export default watchSlidesAccessibility;
